<template>
  <div>
    <v-container>
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="609"
            @click:outside="closeModal"
            :retain-focus="false"
          >
            <v-card class="custom-card" rounded="0">
              <v-toolbar color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">
                  {{ title || 'Repeat Ration'}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card class="pa-10" elevation="0">
                <v-row>
                  <v-col></v-col>
                <v-col cols="9" class="text-center">
                  <h4>{{message1}}</h4>
                  <h4 class="mt-6">{{message2}}</h4>
                </v-col>
                <v-col></v-col>  
                </v-row>
                
                
              </v-card>
                <v-divider></v-divider>
              <v-form ref="addUser" lazy-validation autocomplete="off">
                <v-card-text class="black--text">
                  <v-card-actions style="padding-right: 0">
                    <v-spacer></v-spacer>
                    
                    <v-btn
                      class="mr-2"
                      right
                      height="44"
                      width="116"
                      depressed
                      outlined
                      color="primary"
                      @click="closeModal()"
                    >
                      No
                    </v-btn>

                    <v-btn
                      right
                      height="44"
                      color="primary"
                      @click="repeatRation"
                    >
                      {{confirmBtnText}}
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import gql from 'graphql-tag';
export default {
  data() {
    return {
      rationList: [
        // {
        //   id: 1,
        //   name: "#LP0038-12-01-2022-00082",
        //   updateMode: false,
        // },
        // {
        //   id: 2,
        //   name: "#LP0038-12-01-2022-00082",
        //   updateMode: false,
        // },
        // {
        //   id: 3,
        //   name: "#LP0038-12-01-2022-00082",
        //   updateMode: false,
        // },
        // {
        //   id: 4,
        //   name: "#LP0038-12-01-2022-00082",
        //   updateMode: false,
        // },
        // {
        //   id: 5,
        //   name: "#LP0038-12-01-2022-00082",
        //   updateMode: false,
        // },
      ],
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    rationID:{
      type:Number,
      required:true,
    },
    title: {
            type: String,
            required: true
        },
        message1: {
            type: String,
            required: false
        },
        message2: {
            type: String,
            required: false
        },
        confirmBtnText:{
          type:String,
          required:false
        }
  },
  mixins: [loadingMixin],
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },

    async repeatRation() {
      console.log('test',this.rationID);
      const rationID=this.rationID;
      this.startLoading();
      await this.$apollo
        .mutate({
          mutation:gql`
            mutation repeatRation($id:Int!){
              repeatRation(id:$id){
                id
                reoccur
                name
              }
              }
          `,
          variables: {
            id:Number(rationID)
          },
        })
        .then((res) => {
          this.stopLoading();
          if (res?.data) {
            this.$emit("closeDialog");
            this.$emit("repeatRationDialog");
            
          }
        })
        .catch((err) => {
          console.error(err);
          this.stopLoading();
        });
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field--enclosed .v-input__append-inner {
  margin-top: 10px;
}

::v-deep .v-input__control fieldset {
  border: none;
}
::v-deep .v-input__slot fieldset:first-child {
  border-top: 1px solid #bbb;
}
::v-deep .v-form span:last-child .v-input__slot fieldset {
  border-bottom: 1px solid #bbb;
}
::v-deep .highlightedInput {
  border: 1px solid #00bd73;
  border-width: 1px 0 1px 0;
  border-radius: 0;
}
</style>
